import { render, staticRenderFns } from "./tasks-content.vue?vue&type=template&id=620b7ee5&scoped=true"
import script from "./tasks-content.vue?vue&type=script&lang=ts"
export * from "./tasks-content.vue?vue&type=script&lang=ts"
import style0 from "./tasks-content.vue?vue&type=style&index=0&id=620b7ee5&prod&lang=css"
import style1 from "./tasks-content.vue?vue&type=style&index=1&id=620b7ee5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b7ee5",
  null
  
)

export default component.exports